import React from "react";

import { A11y, Primary } from "@churchofjesuschrist/eden-buttons";
import { Clear } from "@churchofjesuschrist/eden-icons";
import {
  spacing8 as padding,
  spacing32 as buttonGap,
  backgroundColorLevelCurrent,
  yellow40,
} from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

import useManagedStrings from "../../utils/use-managed-strings";

const Bar = styled.div`
  background-color: ${yellow40};
  padding: ${padding};
  display: flex;
  color: ${backgroundColorLevelCurrent};
`;
const Right = styled.div`
  display: flex;
  flex-direction: row-reverse;
  flex: 1;
`;
const Left = styled.div`
  flex: 1;
  padding-top: 4px;
`;
const stringGroups = [
  {
    name: "shared",
    keys: ["impersonating", "changeUser", "stopImpersonating"],
  },
];

const MarginPrimary = styled(Primary)`
  margin-right: ${buttonGap};
`;

const ImpersonationStatus = ({
  impersonating = {},
  onCleared = () => {},
  onChanged = () => {},
}) => {
  const { managedStrings: useStrings } = useManagedStrings(stringGroups);
  if (!impersonating) {
    return null;
  }
  return (
    <Bar>
      <Left>
        {useStrings.impersonating} :{" "}
        <strong>
          {impersonating.displayName} ({impersonating.id})
        </strong>
      </Left>
      <Right>
        <A11y onClick={onCleared}>
          <Clear /> {useStrings.stopImpersonating}
        </A11y>

        <MarginPrimary inverted={true} onClick={onChanged} small={true}>
          {useStrings.changeUser}
        </MarginPrimary>
      </Right>
    </Bar>
  );
};

export default ImpersonationStatus;
